import {FC, useMemo, useRef} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {GetContentBySection,SearchContent,CheckPermissions} from '../../modules/auth/core/_requests'
import React, {useState,useEffect} from 'react'
import LoadingAnimation from '../../LoadingAnimation'
import {UpdateContent,login} from '../../modules/auth/core/_requests';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Button, Form, Modal } from 'react-bootstrap';
import $ from 'jquery';
import {useAuth} from '../../modules/auth'
import { KTIcon } from '../../../_metronic/helpers'
import { Outlet, Route, Routes } from 'react-router-dom'
import { RetrieveRegData } from './components/RetrieveRegData'
import { RegStep1 } from './components/RegStep1'
import { RegStep2 } from './components/RegStep2'
import { RegStep3 } from './components/RegStep3'
import { RegStep4 } from './components/RegStep4'

const aboutBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const EnrolLayout: FC = () => {
  const {saveAuth, setCurrentUser,currentUser} = useAuth()

  const autoLogin= async () => {
    const {data: auth} = await login(localStorage.getItem("xuser") || '{}', localStorage.getItem("xpwd") || '{}')
    saveAuth(auth)
  };
  useEffect(() => {
    //alert("username : " + localStorage.getItem("xuser") || '{}')
    autoLogin()
  }, [])
  return (
    <>
      <PageTitle breadcrumbs={aboutBreadCrumbs}>Registration</PageTitle>
      <div className='card mb-10'>
        <div className='card-body d-flex align-items-center py-8'>
          {/* begin::Icon */}
          <div className='d-flex h-80px w-80px flex-shrink-0 flex-center position-relative'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 24 24'
              className='text-primary h-75px w-75px h-lg-100px w-lg-100px position-absolute opacity-5'
            >
              <path
                fill='currentColor'
                d='M10.2,21.23,4.91,18.17a3.58,3.58,0,0,1-1.8-3.11V8.94a3.58,3.58,0,0,1,1.8-3.11L10.2,2.77a3.62,3.62,0,0,1,3.6,0l5.29,3.06a3.58,3.58,0,0,1,1.8,3.11v6.12a3.58,3.58,0,0,1-1.8,3.11L13.8,21.23A3.62,3.62,0,0,1,10.2,21.23Z'
              ></path>
            </svg>
            <KTIcon iconName='information' className='fs-2x fs-lg-3x text-primary position-absolute' />
          </div>
          {/* end::Icon */}

          {/* begin::Description */}
          <div className='ms-6'>
            <h2>Enrol as participant</h2>
            <p>All form field are mandatory</p>
          </div>
          {/* end::Description */}
        </div>
      </div>
      <div className='card card-custom'>
        <p className='p-10'>
          <Outlet/>
        </p>
      </div>
    </>
  )
}
const EnrolPage = () => (
  <Routes>
    <Route element={<EnrolLayout />}>
      <Route path='participant' element={<RetrieveRegData />} />
      <Route path='participant/step1' element={<RegStep1 />} />
      <Route path='participant/step2' element={<RegStep2 />} />
      <Route path='participant/step3' element={<RegStep3 />} />
      <Route path='participant/step4' element={<RegStep4 />} />
    </Route>
  </Routes>
)
export default EnrolPage
